export const VARIABLES_MAPPING = {
    metaData: '90b0d39f_6661_4b38_8762_dcd62cc1dd46',
    JWToken: 'ac7215cd_fc3f_4704_8bf2_94ecbc74caea',
};

export const DEFAULT_LOCALE = 'en';
